import React, { useEffect } from "react";
import { Props } from "~/components/public-env.tsx";

export default function Parsely() {
  const parselySiteId: string = "talkingpointsmemo.com";

  /*
    add via useEffect to fix hydration error

  */
  useEffect(() => {
    const parselyScript = document.createElement("script");

    parselyScript.innerHTML = `(function(d) {
          var b = d.body;
          var e = d.createElement('script');
          e.id = 'parsely-cfg';
          e.src = '//cdn.parsely.com/keys/${parselySiteId}/p.js';
          e.setAttribute('async','');
          e.setAttribute('defer','');
          b.appendChild(e);
          
        })(document);`;

    document.head.appendChild(parselyScript);
  }, []);
  return <></>; //component needs to return a react node
}
